import { IQuizRequestParams, actions } from "../type";

export const fetchQuizData = (params: IQuizRequestParams) => {
  return {
    type: actions.REQUEST_QUIZ_DATA,
    payload: params,
  };
};

export const saveQuizData = (params: any) => {
  return {
    type: actions.SAVE_QUIZ_DATA,
    payload: params,
  };
};

export const flagQuestion = (params: string) => {
  return {
    type: actions.UPDATE_FLAG,
    payload: params,
  };
};

export const updateAnswer = (
  id: string,
  ans: boolean | null,
  answerVal: any,
  duration: number = 0,
  type: string
) => {
  return {
    type: actions.UPDATE_ANSWER,
    payload: { id, ans, answerVal, duration, type },
  };
};

export const updateAttempts = (id: string) => {
  return {
    type: actions.UPDATE_ATTEMPTS,
    payload: id,
  };
};

export const updateStarted = (started: boolean) => {
  return {
    type: actions.UPDATE_START,
    payload: started,
  };
};

export const updateResume = (resume: boolean) => {
  return {
    type: actions.UPDATE_RESUME,
    payload: resume,
  };
};

export const changeProgressData = (data: any) => {
  return {
    type: actions.UPDATE_QUIZ_PROGRESS,
    payload: data,
  };
};

export const toggleLoading = (data: any) => {
  return {
    type: actions.TOGGLE_LOADING,
    payload: data,
  };
};
